export const ZOHO_EMBED_SESSION = `
  query zohoEmbedSession($tenant_id: Int!, $reportCode: String!, $contexto: JSON) {
    zohoEmbedSession(tenant_id: $tenant_id, reportCode: $reportCode, contexto: $contexto) {
      __typename
      ... on ZohoEmbedSession {
        reporte_codigo
        url
        expira_en
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const ZOHO_EMBED_REPORT_ITEMS = `
  query zohoEmbedReportItems {
    zohoEmbedReportItems {
      __typename
      ... on ReportMenuItem {
        id
        reportCode
        nombre
        categoria
        orden
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
